
export class Hierarchy {
  private state: Obj;
  private district: Obj;
  private ulb: Obj;
  private ward: Obj;
  private area: Obj;

  public getState(): Obj {
    return this.state;
  }

  public setState(state: Obj): void {
    this.state = state;
  }

  public getDistrict(): Obj {
    return this.district;
  }

  public setDistrict(district: Obj): void {
    this.district = district;
  }

  public getUlb(): Obj {
    return this.ulb;
  }

  public setUlb(ulb: Obj): void {
    this.ulb = ulb;
  }

  public getWard(): Obj {
    return this.ward;
  }

  public setWard(ward: Obj): void {
    this.ward = ward;
  }

  public getArea(): Obj {
    return this.area;
  }

  public setArea(area: Obj): void {
    this.area = area;
  }

  constructor(req: any) {
    this.state = new Obj(req.state);
    this.district = new Obj(req.district);
    this.ulb = new Obj(req.ulb);
    this.ward = new Obj(req.ward);
    this.area = new Obj(req.area);
  }
}


export class Obj {

  private id: string;
  private name: string;
  private shortName: string;
  private code: string;

  public getCode(): number {
    return this.code ? parseInt(this.code, 10) : null;
  }

  public setCode(code: string): void {
    this.code = code;
  }

  public getShortName(): string {
    return this.shortName;
  }

  public setShortName(shortName: string): void {
    this.shortName = shortName;
  }

  constructor(req: any) {
    this.id = req?.id;
    this.name = req?.name;
    this.shortName = req?.shortName;
    this.code = req?.code;
  }

  public getId(): string {
    return this.id;
  }

  public setId(id: string): void {
    this.id = id;
  }

  public getName(): string {
    return this.name;
  }

  public setName(name: string): void {
    this.name = name;
  }
}
